import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import BrandLogo from './BrandLogo';
import { gradients, colors } from '../theme/designTokens';

const LoadingScreen = ({ onComplete }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onComplete, 500);
    }, 1800);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <AnimatePresence>
      {visible && (
        <Box
          component={motion.div}
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          sx={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: gradients.hero,
            gap: 3,
          }}
        >
          <BrandLogo
            component={motion.div}
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            imageSx={{ width: 220, maxWidth: '70vw', height: 'auto' }}
          />
          <Box
            component={motion.div}
            initial={{ width: 0 }}
            animate={{ width: 120 }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1], delay: 0.3 }}
            sx={{
              height: 3,
              borderRadius: 2,
              background: `linear-gradient(90deg, ${colors.silver}, ${colors.silverLight})`,
            }}
          />
          <Typography
            component={motion.p}
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 1, 0.6] }}
            transition={{ duration: 1.5, delay: 0.5 }}
            sx={{
              fontFamily: '"Cormorant Garamond", Georgia, serif',
              fontSize: '1.1rem',
              fontWeight: 500,
              letterSpacing: '0.06em',
              color: 'rgba(255,255,255,0.55)',
            }}
          >
            Engineering Resilience
          </Typography>
        </Box>
      )}
    </AnimatePresence>
  );
};

export default LoadingScreen;
